import { SVGAward } from './icons/SVGAward';
import { SVGHighFive } from './icons/SVGHighFive';
import { SVGMapPin } from './icons/SVGMapPin';
import { SVGTarget } from './icons/SVGTarget';
import { SVGThumbsUp } from './icons/SVGThumbsUp';

export const RESOURCES = [
  {
    icon: SVGThumbsUp,
    description: 'This is APM eBook',
    link: 'https://www.apmortgage.com/this-is-apm',
  },
  {
    icon: SVGTarget,
    description: 'Loan Product Playbook',
    link: 'http://www.apmortgage.com/apm-loan-officer-playbook',
  },
  {
    icon: SVGMapPin,
    description: 'Loan Officer Roadmap to Growth',
    link: 'https://www.apmortgage.com/loan-officer-roadmap',
  },
  {
    icon: SVGHighFive,
    description: 'Branch Manager Roadmap to Growth',
    link: 'https://www.apmortgage.com/branch-manager-roadmap',
  },
  {
    icon: SVGAward,
    description: 'Learn More About Employee Ownership',
    link: 'http://www.apmortgage.com/esop-guide',
  },
];

export const FOOTER_LINKS = [
  {
    title: 'Join',
    url: 'https://www.apmortgage.com/join/home',
  },
  {
    title: 'Thrive',
    url: 'https://www.apmortgage.com/thrive',
  },
  {
    title: 'Grow',
    url: 'https://www.apmortgage.com/join/technology',
  },
  {
    title: 'Models',
    url: 'https://www.apmortgage.com/model-of-success',
  },
  {
    title: 'Culture',
    url: 'https://www.apmortgage.com/culture',
  },
  {
    title: 'Connect',
    url: 'https://www.apmortgage.com/join-our-team/contact-me',
  },
  {
    title: 'Blog',
    url: 'https://www.apmortgage.com/joinapm-blog',
  },
  {
    title: 'Careers',
    url:
      'https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=d696f7fe-33a3-4c8d-a8bb-d23282b2aa5d&ccId=19000101_000001&lang=en_US',
  },
  {
    title: 'Press',
    url: 'https://www.apmortgage.com/press-room-old',
  },
];

export const REPUTATION_ASSETS = [
  {
    id: 1,
    alt: 'Top 50 Best Companies to Work For (2014-2022) - Mortgage Executive',
  },
  {
    id: 2,
    alt: 'Top Mortgage Lender (2012-2023) - Scotsman Guide',
  },
  {
    id: 3,
    alt: 'Most Loved Mortgage Employers (2015-2023) - NMP',
  },
  {
    id: 4,
    alt: 'Top Military Lender (2013-2022) - NMP',
  },
  {
    id: 5,
    alt: 'Best Mortgage Companies to Work For (2014-2022) - Mortgage Executive',
  },
  {
    id: 6,
    alt: 'Top Lender (2019-2022) - CALHFA',
  },
  {
    id: 7,
    alt: '5-Star Lender (2021-2022) - Mortgage Professional America',
  },
  {
    id: 8,
    alt: 'Top 15 Mortgage Companies (2013-2023) - Mortgage Executive',
  },
  {
    id: 9,
    alt: 'Top 15 VA Lender (2021-2023) - Scotsman Guide',
  },
];
